<div class="about-main-container">
  <!-- Heading with cta -->

  <!-- <mat-grid-list [cols]="3" style="padding: 0px !important">
    <mat-grid-tile
      class="about-div app-about"
      [colspan]="isMobile() ? 3 : 1"
      [rowspan]="1"
    >
      <img
        src="../../assets/images/mission.svg"
        alt="info"
        style="width: 20%; margin: 2rem 2rem 0px"
        class="mr-1l"
      />
      <div
        class="about-title-heading mr-1l"
        style="text-align: left; margin-left: 2rem"
      >
        Our Mission
      </div>
      <div class="about-title-card">
        <p>
          Inforida aims to make education accessible and affordable for all,
          offering innovative solutions for institutions to enhance efficiency
          and student success. Our diverse team is dedicated to transforming the
          education industry for positive societal impact.
        </p>
      </div>
    </mat-grid-tile>

    <mat-grid-tile
      class="about-div app-about"
      [colspan]="isMobile() ? 3 : 1"
      [rowspan]="1"
    >
      <img
        src="../../assets/images/vision.svg"
        alt="info"
        style="width: 20%; margin: 2rem 2rem 0px"
        class="mr-1l"
      />
      <div
        class="about-title-heading mr-1l"
        style="text-align: left; margin-left: 2rem"
      >
        Our Vision
      </div>
      <div class="about-title-card">
        <p>
          Inforida transforms education with innovative solutions for student
          success. Our easy-to-use, affordable technology empowers educators to
          unlock every student's potential, making operations more efficient.
        </p>
      </div>
    </mat-grid-tile>

    <mat-grid-tile
      class="about-div app-about"
      [colspan]="isMobile() ? 3 : 1"
      [rowspan]="1"
    >
      <img
        src="../../assets/images/story.svg"
        alt="info"
        style="width: 20%; margin: 2rem 2rem 0px"
        class="mr-1l"
      />
      <div
        class="about-title-heading mr-1l"
        style="text-align: left; margin-left: 2rem"
      >
        Our Story
      </div>
      <div class="about-title-card">
        <p>
          Inforida offers innovative financial solutions for educational
          institutes, aiming to enhance efficiency and accessibility. Our
          dedicated team empowers institutions to focus on student success,
          making education more affordable and accessible for all.
        </p>
      </div>
    </mat-grid-tile>
  </mat-grid-list> -->

  <!-- Heading values -->

  <!-- <div class="about-title-heading" style="margin: 150px 20px 60px 20px;">
        Our Values
      </div>

  <div class=" app-value-card">
   
      <div *ngFor="let card of valueCards; let i = index;" class="app-value-tile">
        <div class="value-div" >
          <img src={{card.img}} alt="info" style="height: 35%; margin: 10px;" >
          <div class="value-name-div">
            <p class="value-name">
              {{card.name}}
            </p>
          </div>
          <div class="value-description-div">
            <h3 class="value-description" style="text-align: center;">
              {{card.description}}
            </h3>
          </div>
        </div>
     </div>
  </div> -->

  <div class="heading-container">
    <div class="heading">
      <h1>
        Empowering educational institutions with
        <om-gradient-text
          [text]="'smarter, more connected'"
          [gradientStart]="'#0066fd'"
          [gradientEnd]="'rgba(239, 72, 253, 1)'"
          [pathWidth]="'4px'"
          styleClass="custom-gradient-text"
        ></om-gradient-text>
        management solutions
      </h1>
    </div>
    <p class="heading-des">
      Committed to enabling smarter, connected school ecosystems through
      visionary leadership.
    </p>
    <div class="buttons">
      <button class="button blue" (click)="goToPage()">Learn More</button>
      <button class="button green" (click)="goToWhatsApp()">
        <p style="display: flex">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 39 39"
          >
            <path
              fill="#00E676"
              d="M10.7 32.8l.6.3c2.5 1.5 5.3 2.2 8.1 2.2 8.8 0 16-7.2 16-16 0-4.2-1.7-8.3-4.7-11.3s-7-4.7-11.3-4.7c-8.8 0-16 7.2-15.9 16.1 0 3 .9 5.9 2.4 8.4l.4.6-1.6 5.9 6-1.5z"
            ></path>
            <path
              fill="#FFF"
              d="M32.4 6.4C29 2.9 24.3 1 19.5 1 9.3 1 1.1 9.3 1.2 19.4c0 3.2.9 6.3 2.4 9.1L1 38l9.7-2.5c2.7 1.5 5.7 2.2 8.7 2.2 10.1 0 18.3-8.3 18.3-18.4 0-4.9-1.9-9.5-5.3-12.9zM19.5 34.6c-2.7 0-5.4-.7-7.7-2.1l-.6-.3-5.8 1.5L6.9 28l-.4-.6c-4.4-7.1-2.3-16.5 4.9-20.9s16.5-2.3 20.9 4.9 2.3 16.5-4.9 20.9c-2.3 1.5-5.1 2.3-7.9 2.3zm8.8-11.1l-1.1-.5s-1.6-.7-2.6-1.2c-.1 0-.2-.1-.3-.1-.3 0-.5.1-.7.2 0 0-.1.1-1.5 1.7-.1.2-.3.3-.5.3h-.1c-.1 0-.3-.1-.4-.2l-.5-.2c-1.1-.5-2.1-1.1-2.9-1.9-.2-.2-.5-.4-.7-.6-.7-.7-1.4-1.5-1.9-2.4l-.1-.2c-.1-.1-.1-.2-.2-.4 0-.2 0-.4.1-.5 0 0 .4-.5.7-.8.2-.2.3-.5.5-.7.2-.3.3-.7.2-1-.1-.5-1.3-3.2-1.6-3.8-.2-.3-.4-.4-.7-.5h-1.1c-.2 0-.4.1-.6.1l-.1.1c-.2.1-.4.3-.6.4-.2.2-.3.4-.5.6-.7.9-1.1 2-1.1 3.1 0 .8.2 1.6.5 2.3l.1.3c.9 1.9 2.1 3.6 3.7 5.1l.4.4c.3.3.6.5.8.8 2.1 1.8 4.5 3.1 7.2 3.8.3.1.7.1 1 .2h1c.5 0 1.1-.2 1.5-.4.3-.2.5-.2.7-.4l.2-.2c.2-.2.4-.3.6-.5s.4-.4.5-.6c.2-.4.3-.9.4-1.4v-.7s-.1-.1-.3-.2z"
            ></path>
          </svg>
        </p>
        <p>Join Our community</p>
      </button>
    </div>
  </div>

  <div class="container">
    <div class="platform-header">
      <div class="ph-right">
        <h2>Our <span class="highlights">Core Values</span>.</h2>
      </div>
    </div>
    <div class="cards-container">
      <div class="card" *ngFor="let card of array; let i = index">
        <div class="card-image">
          <div
            class="background-image"
            [style.background-image]="'url(' + card.imgUrl + ')'"
          ></div>
        </div>
        <div class="card-text">
          <h3 class="card-title">{{ card.heading }}</h3>
          <p class="card-description">{{ card.description }}</p>
        </div>
      </div>
    </div>
  </div>

  <div class="timeline-wrapper">
    <h2>Our <span class="highlights">Story</span>.</h2>
    <om-timeline
      [data]="timelineData"
      [entryGap]="'0.5rem'"
      [titleMaxWidth]="'15rem'"
      [entriesGap]="'3.5rem'"
      [orientation]="'left'"
      [pathColor]="'rgba(0, 102, 253, 1)'"
    ></om-timeline>
  </div>

  <div class="team-container">
    <h2 class="">People Who <span class="highlight">Make it</span> happen</h2>

    <div class="team-grid">
      <div class="team-member" *ngFor="let member of teamMembers">
        <div class="profile-image-container">
          <div class="profile-image">
            <img [src]="member.imageUrl" [alt]="member.name + ' profile'" />
          </div>
        </div>
        <div class="position">{{ member.position }}</div>
        <div class="name">{{ member.name }}</div>
        <div class="social-links">
          <a [href]="member.linkedInUrl" target="_blank">LinkedIn</a>
        </div>
      </div>
    </div>
  </div>

  <div class="work-container">
    <div class="work-background"></div>
    <div class="work-content">
      <div class="work-text">
        <h1>Work with us to accelerate Education Revolution</h1>
        <p>Personalised solutions tailored to your school's digital demands</p>
        <button class="work-button" routerLink="/contact-us">
          Talk to an Expert
        </button>
      </div>
    </div>
  </div>

  <!-- Heading team -->
  <!-- <mat-grid-list cols="1" rowHeight="150px">
      <mat-grid-tile [colspan]="1" [rowspan]="1">
        <div>
          <div class="about-title-heading">
            team
          </div>
        </div>
      </mat-grid-tile>
    </mat-grid-list> -->
</div>
